import DisposalQueueModalWindow from '../modals/DisposalQueueModalWindow.tsx';
import moment from 'moment';
import { MessageModalContent } from '@components/modals/MessageModal';
import Timer from '@components/Timer';
import { Button, ButtonSize } from '@components/Button';
import { Modal } from '@components/Modal';
import { cancelReturn } from '@api/apiClient';
import { useQueryClient, useMutation } from 'react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CancelBtn = ({
  id,
  endDate,
  estimatedUtilizationDate,
  tabType,
  handleRefresh,
}: {
  id: string,
  endDate?: string | Date,
  estimatedUtilizationDate: string | Date;
  tabType: string,
  handleRefresh: () => void,
}) => {
  const [isOpenCancelWindow, setIsOpenCancelWindow] = useState(false);
  const [isOpenDisposalQueueWindow, setIsOpenDisposalQueueWindow] = useState(false);

  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const {
    isLoading: isLoadingCancelReturn,
    mutate: mutateCancelReturn
  } = useMutation({
    mutationFn: cancelReturn,
    onSuccess() {
      setIsOpenCancelWindow(true);
      queryClient.invalidateQueries(
        { queryKey: ["getWallet"] }
      );
    }
  });

  const closeCancelWindow = () => {
    setIsOpenCancelWindow(false);
    handleRefresh();
  }

  const closeDisposalWindow = () => {
    setIsOpenDisposalQueueWindow(false);
  }

  return (
    <>
      <Button
        onClick={() => {
          const condition: boolean = estimatedUtilizationDate !== null;
          (condition && moment(estimatedUtilizationDate).diff(moment(), 'hours') < 24)
            ? setIsOpenDisposalQueueWindow(true)
            : mutateCancelReturn(id);
        }}
        size={ButtonSize.XS}
        isRounded
        pending={isLoadingCancelReturn}
        title={(<>{t("disposalTable.resetButton")} {(endDate ? (<Timer endDate={endDate ?? ""} />) : null)}</>)}
      />

      <Modal
        isOpen={isOpenCancelWindow}
        onClose={closeCancelWindow}
        onClickOverlay={closeCancelWindow}
      >
        <MessageModalContent
          title={t("returnCancellationSuccessWindow.title")}
          description={t("returnCancellationSuccessWindow.description")}
          okBtnTitle={t("returnCancellationSuccessWindow.okBtn")}
          onClose={closeCancelWindow}
          mode="success"
        />
      </Modal>

      <Modal
        isOpen={isOpenDisposalQueueWindow}
        onClose={closeDisposalWindow}
        onClickOverlay={closeDisposalWindow}
      >
        <DisposalQueueModalWindow
          parcelId={id}
          estimatedUtilizationDate={estimatedUtilizationDate ?? ""}
          onSuccess={() => {
            handleRefresh();
            closeDisposalWindow();
          }}
          onClose={closeDisposalWindow}
          tabType={tabType}
        />
      </Modal>
    </>
  );
};

export default CancelBtn;
